/* Venisons Heritage 2026 — Theme JS */

(function() {
  'use strict';

  /* ========= HEADER SCROLL ========= */
  const header = document.querySelector('.site-header');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', function() {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 50);
      last = y;
    }, { passive: true });
  }

  /* ========= MOBILE MENU ========= */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close button');

  function openMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.add('active'); document.body.style.overflow = 'hidden'; }
  }
  function closeMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.remove('active'); document.body.style.overflow = ''; }
  }
  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) mobileMenu.addEventListener('click', function(e) {
    if (e.target === mobileMenu) closeMobileMenu();
  });

  /* ========= CART DRAWER ========= */
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartOpen = document.querySelectorAll('[data-cart-open]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('active'); }
    if (cartOverlay) { cartOverlay.classList.add('active'); }
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('active'); }
    if (cartOverlay) { cartOverlay.classList.remove('active'); }
    document.body.style.overflow = '';
  }

  cartOpen.forEach(function(el) { el.addEventListener('click', function(e) { e.preventDefault(); openCart(); }); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(el) { el.textContent = count; });
  }

  function refreshCart() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart) {
      updateCartCount(cart.item_count);
      var items = document.querySelector('.cart-drawer-items');
      var footer = document.querySelector('.cart-drawer-footer');
      if (!items) return;
      if (cart.item_count === 0) {
        items.innerHTML = '<div class="cart-drawer-empty"><p>Your bag is empty</p><a href="/collections/all" class="btn btn-dark">Continue Shopping</a></div>';
        if (footer) footer.style.display = 'none';
        return;
      }
      if (footer) footer.style.display = '';
      var html = '';
      cart.items.forEach(function(item) {
        html += '<div class="cart-drawer-item">';
        html += '<img src="' + (item.image ? item.image.replace(/(\.\w+)$/, '_160x200$1') : '') + '" alt="' + item.title + '">';
        html += '<div class="cart-drawer-item-info">';
        html += '<div class="cart-drawer-item-title">' + item.product_title + '</div>';
        if (item.variant_title) html += '<div class="cart-drawer-item-variant">' + item.variant_title + '</div>';
        html += '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>';
        html += '<button class="cart-drawer-item-remove" data-line-key="' + item.key + '">Remove</button>';
        html += '</div></div>';
      });
      items.innerHTML = html;

      var subtotal = document.querySelector('.cart-drawer-subtotal .subtotal-amount');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      items.querySelectorAll('.cart-drawer-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = this.getAttribute('data-line-key');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function() { refreshCart(); });
        });
      });
    });
  }

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  /* ========= AJAX ADD TO CART ========= */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    }).then(function(r) { return r.json(); }).then(function(item) {
      if (btn) { btn.textContent = 'Added!'; }
      openCart();
      setTimeout(function() { if (btn) { btn.textContent = origText; btn.disabled = false; } }, 1500);
    }).catch(function() {
      if (btn) { btn.textContent = origText; btn.disabled = false; }
    });
  });

  /* ========= PRODUCT GALLERY ========= */
  var mainImg = document.querySelector('.product-gallery-main img');
  var thumbs = document.querySelectorAll('.product-gallery-thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.getAttribute('data-full');
      if (mainImg && src) { mainImg.src = src; }
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ========= VARIANT SELECTOR ========= */
  var variantPills = document.querySelectorAll('.variant-pill');
  var variantInput = document.getElementById('variant-id');
  var variantData = window.__variants || [];

  variantPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      var group = this.getAttribute('data-option-group');
      document.querySelectorAll('.variant-pill[data-option-group="' + group + '"]').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      updateSelectedVariant();
    });
  });

  function getSelectedOptions() {
    var opts = {};
    document.querySelectorAll('.variant-pill.active').forEach(function(p) {
      opts[p.getAttribute('data-option-group')] = p.getAttribute('data-value');
    });
    return opts;
  }

  function updateSelectedVariant() {
    var opts = getSelectedOptions();
    var keys = Object.keys(opts);
    for (var i = 0; i < variantData.length; i++) {
      var v = variantData[i];
      var match = true;
      for (var k = 0; k < keys.length; k++) {
        var idx = parseInt(keys[k]);
        if (v['option' + (idx + 1)] !== opts[keys[k]]) { match = false; break; }
      }
      if (match) {
        if (variantInput) variantInput.value = v.id;
        var priceEl = document.querySelector('.product-info-price');
        if (priceEl) {
          var html = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html = '<span class="compare">' + formatMoney(v.compare_at_price) + '</span> <span class="sale">' + formatMoney(v.price) + '</span>';
          } else {
            html = formatMoney(v.price);
          }
          priceEl.innerHTML = html;
        }
        var addBtn = document.querySelector('.add-to-bag-btn');
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Bag';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          }
        }
        // Update URL
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
        break;
      }
    }
  }

  /* ========= QUANTITY SELECTOR ========= */
  document.querySelectorAll('.quantity-selector').forEach(function(sel) {
    var input = sel.querySelector('input');
    var minus = sel.querySelector('[data-qty="minus"]');
    var plus = sel.querySelector('[data-qty="plus"]');
    if (minus) minus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    if (plus) plus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  /* ========= ACCORDION ========= */
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var panel = this.nextElementSibling;
      var isOpen = this.classList.contains('active');
      this.classList.toggle('active');
      if (isOpen) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ========= COLLECTION SORT ========= */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url;
    });
  }

  /* ========= LAZY LOAD ========= */
  if ('IntersectionObserver' in window) {
    var lazyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
          lazyObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('img[data-src]').forEach(function(img) { lazyObserver.observe(img); });
  }

  /* ========= INIT CART COUNT ========= */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateCartCount(c.item_count);});

})();
